// KaTeX-Styles statisch statt lazy: das Stylesheet versteckt u. a. die
// MathML-Zwillingskopie — lädt es verzögert/gar nicht, erscheinen Formeln
// doppelt ("VkaltVkalt"). 23 kB gzip sind der Preis für Deterministik;
// das große KaTeX-JS bleibt lazy (lib/katex/loader.ts).
import 'katex/dist/katex.min.css';
// Fonts self-hosted (@fontsource) statt Google-CDN — die PWA muss auf der
// Baustelle offline funktionieren, inklusive Typografie.
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import '@fontsource/jetbrains-mono/700.css';
import '@fontsource/jetbrains-mono/800.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import { mount } from 'svelte';
import App from './App.svelte';
import './styles/globals.css';

const target = document.getElementById('app');
if (!target) throw new Error('#app not found');

mount(App, { target });

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('SW register failed:', e));
  });
}
